import { IAdultHouseholdMemberDto, IStatus } from '@/shared/interfaces';
import { fetchIStatus } from '@/shared/fetchIStatus';

export const deleteHouseholdMember = async (
    memberDto: IAdultHouseholdMemberDto,
): Promise<IStatus<string>> => {
    return await fetchIStatus(
        '/api/patients/adult-household-member/delete',
        'post',
        { Cpr: memberDto.Cpr },
    );
};
